import { BaseERC20Factory } from '@arcxgame/contracts/dist/src/typings';
import { useAsync } from './useAsync';
export var useBalance = function (signer, account, erc20Address) {
    return useAsync(function () {
        if (erc20Address) {
            return BaseERC20Factory.connect(erc20Address, signer).balanceOf(account);
        }
        else {
            return signer.getBalance(account);
        }
    }, [account, erc20Address]);
};
//# sourceMappingURL=useBalance.js.map